<div class="container" [ngClass]="{'invalid' : (required && !checkedOptions.length )}">
    <mat-error *ngIf="required && !checkedOptions.length" >
        Merci de choisir au moins une option!
    </mat-error>
    <mat-checkbox *ngFor="let item of options" type="checkbox" [value]="item.value" [(checked)]="item.checked"
        (change)="onToggle($event, item)">{{item.label}}</mat-checkbox>
</div>